import {FocusTermClusteredType} from '@/store/content-optimizer/currentPage';
import {Table} from '@/components/common-components/components';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash} from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';
import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react-lite';
import {useEffect, useState} from 'react';
import {filterDataInMemory} from '@/utils/filter-data';
import styles from './style.module.scss';
import {formatLargeNumber} from '@/utils/number';
import {ColumnType} from 'antd/es/table';

interface Props {
  cluster: FocusTermClusteredType;
  isClusterRemoving: boolean;
}

export const SingleCluster = observer(({
  cluster,
  isClusterRemoving,
}: Props) => {
  const {
    contentOptimizer: {
      currentPage,
    },
  } = useStore('');

  enum SORT_DIRECTION {
    ascend = 'ascend',
    descend = 'descend'
  }

  const [tableData, setTableData] = useState([]);
  const [sortField, setSortField] = useState('requiredCountMin');
  const [sortDirection, setSortDirecion] = useState<SORT_DIRECTION>(SORT_DIRECTION.descend);


  const removeClusterHandler = (term: string) => {
    if (currentPage.isBulkRemovingCluster) return;
    currentPage.bulkRemoveTerms([term], 'term', cluster.title);
  };

  const setTerms = () => {
    const {dataFiltered} = filterDataInMemory(cluster?.focusTerms, '', [], [], 1, cluster?.focusTerms.length, sortField, sortDirection);
    setTableData(dataFiltered);
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    const {column, order} = sorter;
    const {sortFieldName} = column || {};

    setSortField(sortFieldName);
    setSortDirecion(order);
    if (order) {
      const {dataFiltered} = filterDataInMemory(tableData, '', [], [], 1, tableData.length, sortFieldName, order);
      setTableData(dataFiltered);
    } else {
      setTableData(cluster?.focusTerms);
    }
  };

  useEffect(() => {
    setTerms();
  }, [cluster]);

  type ExtendedColumnsType = ColumnType<any> & {defaultSortOrder?: 'ascend' | 'descend'; sortFieldName?: string};

  const tableColumns = (removingTerms: boolean): ExtendedColumnsType[] => {
    return [
      {
        title: 'TOPICAL TERM',
        dataIndex: 'name',
        key: 'name',
        align: 'left' as 'left',
        width: 250,
        render: (_, record) => {
          return <div>
            <span style={{fontSize: 12, marginRight: 5, maxWidth: 140, whiteSpace: 'pre-wrap'}}>{record.name}</span>
            {record?.foundIn && record.foundIn.map((item, idx) => {
              return <FoundInLabel key={idx} className={styles.foundInElement}>{item}</FoundInLabel>;
            })}
            {record?.isBranded && <FoundInLabel>{'branded'}</FoundInLabel>}
          </div>;
        },
      },
      {
        title: 'MSV',
        dataIndex: 'sv',
        key: 'sv',
        align: 'right' as 'right',
        sortFieldName: 'sv',
        width: 60,
        sorter: true,
        render: (_, record) => {
          return <div style={{fontSize: 12, marginRight: 15}}>{formatLargeNumber(record.sv)}</div>;
        },
      },
      {
        title: 'USAGE',
        dataIndex: 'requiredCountMin',
        key: 'requiredCountMin',
        defaultSortOrder: 'descend',
        align: 'right' as 'right',
        width: 60,
        sortFieldName: 'requiredCountMin',
        sorter: true,
        render: (_, record) => {
          return <div style={{fontSize: 12, marginRight: 15}}>{`${record.usedCount}/${record.idealCountMax}`}</div>;
        },
      },
      {
        title: 'REMOVE',
        dataIndex: 'name',
        key: 'name',
        align: 'right' as 'right',
        width: 80,
        render: (_, record) => {
          return <RemoveClusterBtn disabled={removingTerms || isClusterRemoving} onClick={() => removeClusterHandler(record.name)}>
            <FontAwesomeIcon icon={faTrash} className='remove-icon'/>
          </RemoveClusterBtn>;
        },
      },

    ];
  };

  return <div className={styles.tableOuterClusters}>
    <Table
      // className={style.table}
      dataSource={tableData}
      loadingRows={10}
      columns={tableColumns(currentPage.isBulkRemovingCluster)}
      onChange={handleTableChange}
      rowKey='id'
      pagination={false}
    />
  </div>;
});

const RemoveClusterBtn = styled.div<{disabled: boolean}>`
  font-size: 12px;
  color: ${p => p.disabled ? '#A3A4A4': '#4E5156'};
  cursor: ${p => p.disabled ? 'not-allowed': 'pointer'};

  .remove-icon {
    margin-right: 15px;
  }

  &:hover {
    color: #ff6262;
  }
`;
const FoundInLabel = styled.span`
  background-color: #A3A4A426;
  border-radius: 50px;
  display: inline-block;
  font-size: 12px;
  margin-right: 5px;
  padding: 0 8px;
`;
